import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-92d8a158"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_2 = { class: "modal-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Post Creado", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Gestionar Mi Canal", -1))
const _hoisted_6 = { class: "animate form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Redactar Post", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Volver a Gestionar Mi Canal", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Título del Post", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Debe ser conciso y no extenderse más allá de 255 caracteres", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Imagen destacada del Post", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Se mostrará en la preview del Post. Debe tener un tamaño máximo de 4Mb. La resolución ideal es 1280x720 píxeles", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Descripción Corta del Post", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Se muestra en la preview del Post, por lo que debe ser llamativa. No debe extenderse más allá de 255 caracteres", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contenido del Post", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "</>", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref } from 'vue'
//import { useRoute } from 'vue-router'
import ChannelService from '@/services/ChannelService'
import { useAuth } from '@/store/useAuth'
import useWindowWidth from '@/composables/useWindowWidth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import DOMPurify from 'dompurify';
import main from '@/data/main.js'
import CodeI from '@/interfaces/CodeBiteInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'CodePostWrite',
  setup(__props) {

const toast = useToast()
const service = new ChannelService()
const store = useAuth()
const title = ref('')
const short = ref('')
const description = ref('')
const showFeedback = ref(false)
const { windowWidth } = useWindowWidth()
const descriptionBox = ref()
const image = ref()
const feedback = ref('')

const hanldeDescription = () => {
    description.value = DOMPurify.sanitize(descriptionBox.value.getHTML())
    console.log(description.value)
}

const onFileChange = (event:any) => {
    const file = event.target.files[0];
    image.value = file;
};

const storeCodepost = async () => {
    if (!store.token) { return; }

    if(title.value.length < 3 || title.value.length > 255) {
        toast.showToast("La extensión del título no es válida.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    if(short.value.length < 3 || short.value.length > 255) {
        toast.showToast("La extensión de la descripción corta no es válida.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    if(description.value.length < 10) {
        toast.showToast("La extensión del contenido es demasiado corta.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    if(!image.value) {
        toast.showToast("La imagen es un campo requerido.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }


    feedback.value = "Subiendo...";
    const response = await service.CreateCodePost(store.token, title.value, description.value, short.value, image.value)

    if (response.success != true) {
        toast.showToast(response.message, Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        feedback.value = ''
        return
    }

    feedback.value = ''
    showFeedback.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (showFeedback.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_unref(windowWidth) >= 1000)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(main).POST_IMG,
                    style: {"width":"100%"}
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              _createVNode(_component_RouterLink, {
                to: { name: 'social-profile-edit' },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_RouterLink, {
          to: { name: 'social-profile-edit' },
          style: {"text-decoration":"none"}
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
          type: "text",
          max: "255",
          maxlength: "255",
          required: ""
        }, null, 512), [
          [_vModelText, title.value]
        ]),
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("input", {
          class: "input",
          type: "file",
          onChange: onFileChange,
          required: ""
        }, null, 32),
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((short).value = $event)),
          type: "text",
          max: "255",
          maxlength: "255",
          required: ""
        }, null, 512), [
          [_vModelText, short.value]
        ]),
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("p", null, [
          _createTextVNode("Usa la herramienta "),
          _hoisted_21,
          _createTextVNode(" para escribir código. Mejorará mucho su legibilidad. Al contrario que la "),
          _createVNode(_component_RouterLink, { to:  { name: 'new-codebite' }  }, {
            default: _withCtx(() => [
              _createTextVNode(" creación de un Short")
            ]),
            _: 1
          }),
          _createTextVNode(", los Posts son extensos y detallados artículos para aquellos que desean ir más allá ")
        ]),
        _createVNode(_component_quill_editor, {
          ref_key: "descriptionBox",
          ref: descriptionBox,
          theme: "snow",
          toolbar: "full",
          "onUpdate:content": hanldeDescription
        }, null, 512),
        _hoisted_22,
        _createElementVNode("button", {
          class: "new-question",
          onClick: storeCodepost
        }, [
          _createTextVNode("Crear Post "),
          _createVNode(_component_v_icon, {
            name: "io-send",
            style: {"margin-left":"10px"}
          })
        ]),
        _createElementVNode("small", null, _toDisplayString(feedback.value), 1)
      ])
    ]),
    _: 1
  }))
}
}

})